import { getWindowHeight } from 'ava-util/dist/dom-window';

const BOTTOM_SPACE = 10;

export function getMenuMaxHeight(trigger: HTMLElement):string {
    if (!trigger) {
        return 'none';
    }
    const rect = trigger.getBoundingClientRect();
    const maxHeight = getWindowHeight() - rect.top - rect.height - BOTTOM_SPACE;
    return `${maxHeight}px`;
}